<template>
	<div class="subscription__item">
		<div class="subscription__name">{{ subscription.name }} <span v-if="isSelected" class="subscription__name-active">(Active)</span></div>
		<p v-if="subscription.description" class="subscription__description">{{ subscription.description }}</p>
		<div class="subscription__price">{{ currencySign }}<span :class="{ 'subscription__price-green': subscriptionPrice === 'Free' }">{{ subscriptionPrice }}</span></div>
		<button v-if="isSelected && isRecurring" class="subscription__button-cancel" @click="openModal">Cancel</button>
		<button v-else-if="!isSelected" class="subscription__button-select" @click="handleSelectSubscription">Select subscription</button>
		<div v-if="iframeSrc" class="modal">
			<div class="payment-modal-box">
				<div class="modal-header">
					<span class="modal-title">Payment</span>
					<span class="modal-close" @click="closeIframe">&#10005;</span>
				</div>
				<div class="iframe-container" id="payment-iframe">
					<iframe :src="iframeSrc"></iframe>
				</div>
			</div>
		</div>
		<CancelSubscriptionModal :isOpen.sync="isCancelModalOpen" @onConfirm="handleCancelSubscription" />
		<Message :visible="!!message" :text="message" @update:visible="updateMessageVisibility" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import CancelSubscriptionModal from '../../../../components/ui/cancel-subscription-modal.vue';
import Message from '__jsVueUI/message.vue';

const currencies = {
	USD: '$',
	EUR: '€',
	UAH: '₴'
};
export default {
	name:  'SubscriptionItem',
	props: {
		subscription: {
			type: Object
		},
	},
	components: {
		CancelSubscriptionModal,
		Message
	},
	data() {
		return {
			currencySign:      currencies[this.subscription.currency],
			iframeSrc:         null,
			isCancelModalOpen: false,
		};
	},
	computed: {
		isSelected() {
			return this.subscription.is_subscribed;
		},
		isRecurring() {
			return this.subscription.type === 'recurring';
		},
		subscriptionPrice() {
			return +this.subscription.amount === 0 ? 'Free' : this.subscription.amount;
		},
		...mapState({
			message: state => state.main.message
		}),
	},
	methods: {
		async handleSelectSubscription() {
			this.iframeSrc = `${this.subscription.payment_url}?email=${this.$store.state.profile.profile.email}&phone=${this.$store.state.profile.profile.phone}&firstName=${this.$store.state.profile.profile.first_name}&lastName=${this.$store.state.profile.profile.last_name}`;
		},
		async handleCancelSubscription(params) {
			await this.$store.dispatch('profile/cancelSubscription', params);
		},
		async closeIframe() {
			this.iframeSrc = null;
			await this.$store.dispatch('deals/loadSubscriptionList');
		},
		openModal() {
			this.isCancelModalOpen = true;
		},
		updateMessageVisibility(visible) {
			if (!visible) {
				this.$store.commit('main/setMessage', null, { root: true });
			}
		}
	}
};
</script>
